import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-recoverfinished',
  templateUrl: './recoverfinished.component.html',
  styleUrls: ['./recoverfinished.component.css']
})
export class RecoverfinishedComponent implements OnInit {

  private destroy$ = new Subject();

  constructor(private _data:DataService,
              private _blogic:BusinesLogicService) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Recover finished turn */
  public recoverFinished():void {
    let params:object = {
        turn_id: this._data.selectedTurn["id"],
        desk_id: this._data.selectedTurn["desk_id"],
        fromqueue: 0,
        toqueue: 0,
        kind_id: 0,
        position: 'S'
    };

    this._blogic.moveTurn(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response:any) => {
          this._data.actionContainer = 0;
        }
      );
  }

}
